import * as React from "react"

import { cn } from "@/lib/utils"

/* Tabela — arquivo do shadcn, reestilizada para a Colmeia.
 *
 * Densa e numérica. O cabeçalho segue `.rotulo`: quem lê a tabela lê os
 * NÚMEROS, e o cabeçalho só precisa dizer de que coluna são. Sem faixa
 * zebrada e sem borda externa: o que separa duas linhas é um fio de 10% e
 * nada mais. */

function Table({ className, ...props }: React.ComponentProps<"table">) {
  return (
    <div
      data-slot="table-container"
      className="relative w-full overflow-x-auto"
    >
      <table
        data-slot="table"
        className={cn("w-full caption-bottom border-separate border-spacing-0 text-apoio", className)}
        {...props}
      />
    </div>
  )
}

function TableHeader({ className, ...props }: React.ComponentProps<"thead">) {
  return (
    <thead
      data-slot="table-header"
      className={cn(className)}
      {...props}
    />
  )
}

function TableBody({ className, ...props }: React.ComponentProps<"tbody">) {
  return (
    <tbody
      data-slot="table-body"
      className={cn("[&_tr:first-child_td]:border-t-0 [&_td]:border-t", className)}
      {...props}
    />
  )
}

function TableFooter({ className, ...props }: React.ComponentProps<"tfoot">) {
  return (
    <tfoot
      data-slot="table-footer"
      className={cn(
        "bg-lavado font-semibold [&>tr>td]:border-t-0",
        className
      )}
      {...props}
    />
  )
}

function TableRow({ className, ...props }: React.ComponentProps<"tr">) {
  return (
    <tr
      data-slot="table-row"
      className={cn(
        "transition-colors hover:bg-lavado has-aria-expanded:bg-lavado data-[state=selected]:bg-lavado",
        className
      )}
      {...props}
    />
  )
}

function TableHead({ className, ...props }: React.ComponentProps<"th">) {
  return (
    <th
      data-slot="table-head"
      className={cn(
        // Mesmo desenho do `.rotulo` (13px, peso 600, --tinta-2), escrito em
        // utilitário porque `th` precisa de alinhamento e respiro próprios e
        // `.rotulo` é `display:block`, que quebraria a célula da tabela.
        "px-3 pb-3 text-left align-bottom text-apoio font-semibold whitespace-nowrap text-tinta-2 [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        className
      )}
      {...props}
    />
  )
}

function TableCell({ className, ...props }: React.ComponentProps<"td">) {
  return (
    <td
      data-slot="table-cell"
      className={cn(
        "h-linha-tabela px-3 py-2.5 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        className
      )}
      {...props}
    />
  )
}

function TableCaption({
  className,
  ...props
}: React.ComponentProps<"caption">) {
  return (
    <caption
      data-slot="table-caption"
      className={cn("mt-4 text-nota text-tinta-2", className)}
      {...props}
    />
  )
}

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
}
